import { create } from 'zustand';

export enum ESummaryState {
  PURCHASE_DATA = 'purchase_data',
}

interface ISummaryState {
  title: string;
  setTitle: (title: string) => void;
  currentStep: ESummaryState;
  setCurrentStep: (summaryState: ESummaryState) => void;
}

export const useSummaryState = create<ISummaryState>(set => {
  return {
    title: '',
    setTitle: (title: string) => set({ title }),
    currentStep: ESummaryState.PURCHASE_DATA,
    setCurrentStep(newSelectedData: ESummaryState) {
      set({ currentStep: newSelectedData });
    },
  };
});
